<template>
    <component :is="component" v-if="component" :utilityData="utilityData" :paginationData="paginationData"></component>
</template>

<script>
export default {
    name: "UtilityListLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: '',
        utilityData: {default: () => []},
        paginationData: {default: {page: 1, size: 10, total: 0}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/utility/list/UtilityListDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/utility/list/${this.listLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
